module.exports = __webpack_public_path__ + "static/img/witness-kids-3.29430b2d.png";